import { createResource } from '@atlassian/react-resource-router';

const RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS = 'ADMIN_OAUTH_CREDENTIALS';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const adminOauthCredentialsResource = createResource<any>({
	type: RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS,
	getKey: () => 'state',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-admin-oauth-credentials", jiraSpaEntry: "async-resource-admin-oauth-credentials" */ './get-data'
		),
});
